export const messages = {
  login: {
    label: {
      id: 'confirmEmail.Login.Label',
      defaultMessage: 'Log in',
    },
  },
  usernameTitle: {
    label: {
      id: 'confirmEmail.UserNameTitle.Label',
      defaultMessage: 'Username',
    },
  },
  passwordTitle: {
    label: {
      id: 'confirmEmail.PasswordTitle.Label',
      defaultMessage: 'Password',
    },
  },
  required: {
    error: {
      id: 'confirmEmail.Required.Error',
      defaultMessage: 'Required',
    },
  },
  page: {
    title: {
      id: 'confirmEmail.Page.Title',
      defaultMessage: 'Confirm Your Email',
    },
  },
  intro: {
    label: {
      id: 'confirmEmail.Intro.Label',
      defaultMessage: 'Log in to confirm your email address.',
    },
  },
};
